/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Challenge_Active_DaysInputs */

const en_us2_clubs_challenge_active_days = /** @type {(inputs: Clubs_Challenge_Active_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active days`)
};

const pt_br2_clubs_challenge_active_days = /** @type {(inputs: Clubs_Challenge_Active_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias ativos`)
};

const es_419_clubs_challenge_active_days = /** @type {(inputs: Clubs_Challenge_Active_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Días activos`)
};

const pt_pt2_clubs_challenge_active_days = /** @type {(inputs: Clubs_Challenge_Active_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias ativos`)
};

const fr_fr2_clubs_challenge_active_days = /** @type {(inputs: Clubs_Challenge_Active_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jours actifs`)
};

const de_de2_clubs_challenge_active_days = /** @type {(inputs: Clubs_Challenge_Active_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Tage`)
};

const it_it2_clubs_challenge_active_days = /** @type {(inputs: Clubs_Challenge_Active_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni attivi`)
};

/**
* | output |
* | --- |
* | "Active days" |
*
* @param {Clubs_Challenge_Active_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_challenge_active_days = /** @type {((inputs?: Clubs_Challenge_Active_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Challenge_Active_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_challenge_active_days(inputs)
	if (locale === "es-419") return es_419_clubs_challenge_active_days(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_challenge_active_days(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_challenge_active_days(inputs)
	if (locale === "de-DE") return de_de2_clubs_challenge_active_days(inputs)
	if (locale === "it-IT") return it_it2_clubs_challenge_active_days(inputs)
	return en_us2_clubs_challenge_active_days(inputs)
});
export { clubs_challenge_active_days as "clubs.challenge_active_days" }